exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".total[data-v-dcda1b7c]{background:#e9f0ff;border:.06rem solid #f0f0f0;border-radius:.25rem;width:calc(100% - 4rem);padding:1.5rem 2rem;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;margin-top:1.25rem}.item[data-v-dcda1b7c]{text-align:center}.item img[data-v-dcda1b7c]{width:2.19rem;height:2.19rem;margin-bottom:.25rem}.count[data-v-dcda1b7c]{font-size:1.5rem;color:#0f295f;font-weight:700;margin-bottom:.25rem}.title[data-v-dcda1b7c]{font-size:.88rem;color:#434343;font-weight:400}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-dcda1b7c&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/total.vue
// module id = 503
// module chunks = 0